<template>
  <div class="result-wrapper">
    <div class="result-card">
      <img :src="config.icon" :alt="config.iconAlt" class="result-icon">
      <h1 class="result-title">{{ config.title }}</h1>
      <p v-if="config.description" class="result-text">
        {{ config.description }}
      </p>
      <main-button depressed @click="$emit('primaryClick')">
        {{ config.buttonLabel }}
      </main-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'membership-request-result',
  props: {
    status: {
      type: String,
      required: true,
    },
  },
  computed: {
    config() {
      if (this.status === 'success') {
        return {
          icon: '/assets/Success.svg',
          iconAlt: 'success',
          title: this.$t('membershipRequestSuccess'),
          description: this.$t('membershipRequestDescription'),
          buttonLabel: this.$t('newRequest'),
        }
      }

      return {
        icon: '/assets/Error.svg',
        iconAlt: 'error',
        title: this.$t('membershipRequestError'),
        description: this.$t('membershipRequestErrorDescription'),
        buttonLabel: this.$t('tryAgain'),
      }
    },
  },
}
</script>

<style scoped>
.result-wrapper {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4rem 1rem;
}

.result-card {
  width: 100%;
  max-width: 803px;
  text-align: left;
}

.result-icon {
  width: 72px;
}

.result-title {
  margin: 1.5rem 0 0.75rem;
  font-family: 'Raleway';
  font-weight: 700;
  font-size: 1.75rem;
}

.result-text {
  margin-bottom: 2rem;
  font-size: 1rem;
  color: #555;
}
</style>
